import React, { useContext } from 'react'
import { Helmet as ReactHelmet } from 'react-helmet'
import { useSiteMetadata } from '../hooks/MetaData'
import LayoutContext from './LayoutContext'

const Helmet = ({ title = 'Pozala Residences & Penthouses', meta = [], description = '' }) => {
    const { currentLang, languageData } = useContext(LayoutContext)
    const { siteUrl, siteTitle } = useSiteMetadata()

    return (
        <ReactHelmet
            htmlAttributes={{ lang: currentLang.langKey }}
            title={title}
            meta={[
                {
                    charSet: 'utf-8',
                },
                {
                    name: `description`,
                    content: description,
                },
                {
                    property: `og:site_name`,
                    content: siteTitle,
                },
                {
                    property: `og:type`,
                    content: 'website',
                },
                {
                    property: `og:title`,
                    content: title,
                },
                {
                    property: `og:description`,
                    content: description,
                },
                {
                    property: `og:locale`,
                    content: currentLang.langKey,
                },
                {
                    property: `twitter:title`,
                    content: title,
                },
                {
                    property: `twitter:description`,
                    content: description,
                },
                {
                    property: `twitter:card`,
                    content: 'summary',
                },
            ].concat(meta)}
            link={[
                {
                    rel: 'canonical',
                    href: `${siteUrl}${currentLang.link}`,
                },
                {
                    rel: 'alternate',
                    hrefLang: 'x-default',
                    href: `${siteUrl}${languageData[0].link}`,
                },
                ...languageData.map((lang) => ({
                    rel: 'alternate',
                    hrefLang: lang.langKey,
                    href: `${siteUrl}${lang.link}`,
                })),
            ]}
        />
    )
}

export default Helmet
